<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="6">
                    <ValidationProvider name="day_part" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('day_part')">
                            <ParameterSelectbox code="session_day_parts" v-model="form.day_part" :validate-error="errors[0]">
                            </ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="day_type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('day_type')">
                            <ParameterSelectbox code="session_day_types" v-model="form.day_type" :validate-error="errors[0]">
                            </ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="module_date_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('module_date')">
                            <module-date-selectbox ref="moduleDate" v-model="form.module_date_id" :validate-error="errors[0]">
                            </module-date-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
              <b-col cols="6">
                <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('program')">
                    <program-selectbox level="E" :validate-error="errors[0]" v-model="form.program_code"></program-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
                <b-col cols="6">
                    <ValidationProvider name="course_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('course')">
                            <esl-course-selectbox
                                :validate-error="errors[0]"
                                :is-program-code-required="true"
                                :program-code="form.program_code"
                                v-model="form.course_id"></esl-course-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
              <b-col cols="6">
                <ValidationProvider name="section" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('section')">
                    <b-form-input type="number" v-model="form.section"
                                  :validateError="errors[0]"/>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
                <b-col cols="6">
                    <ValidationProvider name="start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <select-date
                                v-model="form.start_date"
                                :is-time="false"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <select-date
                                v-model="form.end_date"
                                :is-time="false"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="instructor_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('teaching_staff')">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="start_time" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input
                                type="time"
                                v-model="form.start_time"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="end_time" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input
                                type="time"
                                v-model="form.end_time"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="evaluation_id" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('evaluation')">
                            <evaluation-selectbox v-model="form.evaluation_id"></evaluation-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="classroom_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('classroom')">
                            <classroom-selectbox v-model="form.classroom_id" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="quota " rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input type="number" v-model="form.quota "
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="student_number" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student_numbers')">
                            <lined-textarea v-model="student_numbers"
                                            :nowrap="false"
                                            :disabled="false"
                                            :styles="{ height: '10em', resize: 'both' }"
                                            :validateError="errors[0]">
                            </lined-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="class_modality" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('class_modality')">
                            <parameter-selectbox v-model="form.class_modality"
                                                 :validate-error="errors[0]"
                                                 code="session_class_modalities"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

            </b-row>
        </ValidationObserver>

        <div class="col-12 mt-3 d-flex">
            <b-button
                @click="createForm"
                type="button"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import SessionService from "@/services/SessionService";
//Components
import EvaluationSelectbox from "@/components/interactive-fields/EvaluationSelectbox.vue";
import EslCourseSelectbox from "@/components/interactive-fields/EslCourseSelectbox.vue";
import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";
import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";
import LinedTextarea from "../../../components/elements/LinedTextarea.vue";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

export default {
    components: {
        ModuleDateSelectbox,
        LinedTextarea,
        ClassroomSelectbox,
        ValidationProvider,
        ValidationObserver,
        EvaluationSelectbox,
        EslCourseSelectbox,
        StaffAutoComplete,
        ParameterSelectbox
    },
    data() {
        return {
            student_numbers:"",
            formLoading: false,
            form: {
                module_date_id: null,
                course_id: null,
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null,
                evaluation_id: null,
                classroom_id: null,
                class_modality: null,
                instructor_id: null,
                quota: null,
                section: 1,
            }
        }
    },
    methods: {
        async createForm() {

            if (this.checkPermission('session_store')) {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    if (this.student_numbers && this.student_numbers !== null) {
                        let student_numbers = this.student_numbers.split("\n")
                        this.form.student_numbers = student_numbers

                    }
                    SessionService.store(this.form)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$emit("createFormSuccess")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    },
    watch:{
        'form.module_date_id': function (newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
                let item=this.$refs.moduleDate.getItem(newValue);
                if (item) {
                    this.form.start_date = item.start_date;
                    this.form.end_date = item.end_date;
                }
            }
        },
    }
}
</script>
